import sileo from 'sileo';

const Category = new sileo.Model('ministry_new', 'category');
// const TopicAttachment = new sileo.Model('ministry_new', 'topic-attachment');
const SubCategory = new sileo.Model('ministry_new', 'subcategory');
const Topic = new sileo.Model('ministry_new', 'simple-topic-data');
const TopicTag = new sileo.Model('ministry_new', 'topic-tags');
const Details = new sileo.Model('ministry_new', 'topic-details');

const TopicsSimpleData = new sileo.Model('ministry_new', 'simple-topic-data');


const state = {
    topics: {},
    topicsSimpleData: [],
    helpCategories: [],
    helpTopics: [],
    helpTopicsCategories: [],
    helpSubCategories: []
};

const mutations = {
    setTopics(state, data) {
        state.topics = data;
    },
    setTopicsSimpleData(state, data) {
        state.topicsSimpleData = data;
    },
    setCategories(state, data) {
        state.helpCategories = data;
    },
    setTopicsCategories(state, helpTopicsCategories = {}) {
        state.helpTopicsCategories = helpTopicsCategories;
    },

    setSubCategories(state, data) {
        state.helpSubCategories = data;
    },
};

const actions = {
    getCategory(context, pk) {
        return Category.objects.get(pk);
    },

    fetchTopics(context, filters) {
        return Topic.objects.filter(filters);
    },


    fetchTopicDetails(context, filters) {
        return Details.objects.filter(filters);
    },


    getTopicDetails(context, pk) {
        return Details.objects.get(pk);
    },

    fetchHelpCategories(context, filters) {
        return Category.objects.filter(filters);
    },

    getSubcategory(context, pk) {
        return SubCategory.objects.get(pk);
    },

    fetchTopicTags(context, filter) {
        return TopicTag.objects.filter(filter);
    },

    fetchHelpSubCategories(context, filters) {
        return SubCategory.objects.filter(filters);
    },

    fetchSimpleDataTopics(context, filters) {
        return TopicsSimpleData.objects.filter(filters);
    }
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};
